import { render, staticRenderFns } from "./attribute-form-dialog.app.vue?vue&type=template&id=e18c0338&"
import script from "./attribute-form-dialog.app.vue?vue&type=script&lang=js&"
export * from "./attribute-form-dialog.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports